import React, { useState, useEffect } from 'react';
import Dashboardbg2 from '../../images/CricketStadium.png';
import Dashboardbg3 from '../../images/Pool.png';
import Dashboardbg4 from '../../images/Resort2.png';
import Dashboardbg5 from '../../images/KidZone.png';
import '../../components/Styles/carousel.css'; // Add custom carousel CSS

const ImageCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const contentList = [
    {
      image: Dashboardbg2,
      heading: 'Discover the Best Sports Facilities',
      subtext: 'Play the game, feel the passion!',
    },
    {
      image: Dashboardbg3,
      heading: 'Book your swim day',
      subtext: 'Way of water',
    },
    {
      image: Dashboardbg4,
      heading: 'Experience exotic locations',
      subtext: 'Experience is the way to live',
    },
    {
      image: Dashboardbg5,
      heading: 'Plan a day for your kids',
      subtext: 'Happy kids, peaceful sleep',
    },
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % contentList.length);
    }, 5000);

    return () => clearInterval(intervalId);
  }, [contentList.length]);

  const prevIndex = (currentIndex - 1 + contentList.length) % contentList.length;
  const nextIndex = (currentIndex + 1) % contentList.length;

  // Handler for setting the previous image as the current image
  const handlePrevClick = () => {
    setCurrentIndex(prevIndex);
  };

  // Handler for setting the next image as the current image
  const handleNextClick = () => {
    setCurrentIndex(nextIndex);
  };

  return (
    <div className="carousel-container">
      {/* Previous card */}
      <div className="carousel-card previous-card" onClick={handlePrevClick}>
        <img 
          src={contentList[prevIndex].image} 
          alt="Previous" 
          className="carousel-image" 
        />
      </div>

      {/* Main card */}
      <div className="carousel-card main-card">
        <img 
          src={contentList[currentIndex].image} 
          alt="Main" 
          className="carousel-image" 
        />
        <div className="carousel-content">
          <h1 className="carousel-heading">
            {contentList[currentIndex].heading}
          </h1>
          <p className="carousel-subtext">
            {contentList[currentIndex].subtext}
          </p>
        </div>
      </div>

      {/* Next card */}
      <div className="carousel-card next-card" onClick={handleNextClick}>
        <img 
          src={contentList[nextIndex].image} 
          alt="Next" 
          className="carousel-image" 
        />
      </div>
    </div>
  );
};

export default ImageCarousel;
